export function detectPlatform(): string {
  if (typeof window === "undefined") return "Web"

  // Check native platform injected by WebView
  const nativePlatform = (window as any).__WELLTRAINER_NATIVE_PLATFORM__
  if (nativePlatform === "ios") return "iOS"
  if (nativePlatform === "android") return "Android"

  const ua = navigator.userAgent || ""

  // Check if running inside a WebView (Expo/React Native)
  const isWebView =
    ua.includes("wv") ||
    ua.includes("WebView") ||
    (window as any).ReactNativeWebView !== undefined

  if (/android/i.test(ua)) return isWebView ? "Android" : "Web"
  if (/iPad|iPhone|iPod/.test(ua)) return isWebView ? "iOS" : "Web"

  return "Web"
}

export function isIOSNative(): boolean {
  return detectPlatform() === "iOS"
}

export function isAndroidNative(): boolean {
  return detectPlatform() === "Android"
}

export function isNativeApp(): boolean {
  const platform = detectPlatform()
  return platform === "iOS" || platform === "Android"
}

export type PlataformaOrigem = "app_ios" | "app_android" | "mobile_web" | "desktop"

/**
 * Plataforma de origem normalizada para a Jornada (analytics de churn).
 * Distingue 4 casos:
 *   - app_ios / app_android: app nativo (WebView Expo injeta __WELLTRAINER_NATIVE_PLATFORM__)
 *   - mobile_web: navegador em celular (sem o app instalado)
 *   - desktop: navegador em tela grande
 * Enviado no header X-Plataforma-Origem em toda requisicao (ver lib/api.ts).
 */
export function detectPlataformaOrigem(): PlataformaOrigem {
  if (typeof window === "undefined") return "desktop"

  const nativePlatform = (window as any).__WELLTRAINER_NATIVE_PLATFORM__
  if (nativePlatform === "ios") return "app_ios"
  if (nativePlatform === "android") return "app_android"

  const ua = navigator.userAgent || ""
  const ehMobile =
    /mobile|iphone|ipod|android|iemobile|blackberry|opera mini/i.test(ua) ||
    // iPadOS 13+ se identifica como Macintosh com touch
    (/macintosh/i.test(ua) && (navigator as any).maxTouchPoints > 1)

  return ehMobile ? "mobile_web" : "desktop"
}
